import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, output, Output, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

type TabKey =
  | 'inicio'
  | 'mis-datos'
  | 'reservas'
  | 'mi-wallet'
  | 'beneficios'
  | 'recompensas'
  | 'promotor';

@Component({
  selector: 'lib-dashboard-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-tabs.html',
  styleUrls: ['./dashboard-tabs.scss'],
})
export class DashboardTabs implements OnInit {

  private router = inject(Router);

  public active = signal<string>('inicio');

  selected = output<TabKey>();

  constructor() {
    
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed()
    ).subscribe(() => {
      this.syncActiveTab();
    });
  }

  ngOnInit() {
    this.syncActiveTab();
  }

  readonly items: { key: TabKey; label: string; icon: string; path: string }[] =
    [
      {
        key: 'inicio',
        label: 'Inicio',
        icon: '/member/dashboard/menu-board.svg',
        path: 'dashboard',
      },
      {
        key: 'mis-datos',
        label: 'Mis datos',
        icon: '/member/dashboard/user-square.svg',
        path: 'data',
      },
      {
        key: 'reservas',
        label: 'Reservas',
        icon: '/member/dashboard/fi-rr-bed.svg',
        path: 'member-booking-feature',
      },
      {
        key: 'mi-wallet',
        label: 'Mi wallet',
        icon: '/member/dashboard/wallet.svg',
        path: 'dashboard/wallet',
      },
      {
        key: 'beneficios',
        label: 'Beneficios',
        icon: '/member/dashboard/user-double.svg',
        path: 'benefits',
      },
      {
        key: 'recompensas',
        label: 'Recompensas',
        icon: '/member/dashboard/cup.svg',
        path: 'dashboard/rewards',
      },
      {
        key: 'promotor',
        label: 'Promotor',
        icon: '/member/dashboard/megaphone.svg',
        path: 'promotor',
      },
    ];

  onTab(path: string, key: string) {
    this.active.set(key);
    
    this.router.navigateByUrl(path);
  }

  private syncActiveTab() {
  
    const urlSegments = this.router.url.split('?')[0].split('/').filter(s => s !== '');
    const lastUrlSegment = urlSegments[urlSegments.length - 1];

    const found = this.items.find(item => {
      const cleanItemPath = item.path.split('/').filter(s => s !== '').pop();
      
      return cleanItemPath === lastUrlSegment;
    });

    if (found) {
      this.active.set(found.key);
    }
  }
}

